import React from "react";
import Modal from "../Modal";

import LoadableComponent from "./loadable";
import { IProps } from "./interfaces";

export default (
    (props: IProps) => (
        <Modal close={props.close}>
            <LoadableComponent {...props} />
        </Modal>
    )
);
